<template>
<div
  class="kt-portlet kt-portlet--bordered"
  :class="{ 'collapsed': isCollapsed, 'border-danger': isSelected }"
  v-on="$listeners">
  <div
    class="kt-portlet__head px-3"
    :class="{ 'kt-bg-info': !isDropped, 'kt-bg-danger': isDropped || isSelected }">
    <div class="kt-portlet__head-label">
      <h3 class="kt-portlet__head-title d-flex align-items-center">
        <font-awesome-icon :icon="['fas', 'circle']" size="lg" v-if="isSelectable && !isSelected" class="iconDragAndDrop" />
        <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" v-if="isSelectable && isSelected" class="iconDragAndDrop" />
        <font-awesome-icon :icon="['fas', 'arrows-alt']" size="lg" v-if="!isSelectable" class="iconDragAndDrop" />
        <span
          v-if="isDropped && isCollapsed"
          class="kt-badge bg-white text-color2 font-weight-bold ml-2 mr-1">{{ order }}</span>
        <span class="ml-2 date-kt-badge" v-if="data && !data.isADay && data.title" v-html="data.title"></span>
        <span class="ml-2 date-kt-badge" v-if="data && data.isADay && data.itineraryTitle" v-html="data.itineraryTitle"></span>
        <span :class="{ 'ml-1': isDropped }" v-if="isDropped && isCollapsed">:</span>
        <span :class="{ 'ml-2': isDropped }" v-if="isDropped && isCollapsed && data && data.isADay && data && data.title" v-html="data.title"></span>
        <span class="ml-1 theme-drag-drop" v-if="data && !data.isADay && data.theme">| {{ data.theme }}</span>
        <span class="ml-1 theme-drag-drop" v-if="data && data.isADay && data.itineraryTheme">| {{ data.itineraryTheme }}</span>
      </h3>
    </div>
    <div class="font-weight-normal text-right" v-if="data.brand_name">
      {{ data.brand_name }}
    </div>
    <div class="font-weight-normal text-right" v-if="data && data.isADay && data.itineraryBrand">
      {{ data.itineraryBrand }}
    </div>
  </div>
  <div class="kt-portlet__body py-2 px-3 collapsed">
    <div class="d-flex justify-content-between fw-600 py-0">
      <span :class="{ 'text-info': !isDropped, 'text-color2': isDropped || isSelected }">
        <span class="kt-badge kt-badge--danger" v-if="isDropped">{{ order }}</span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.tour_name && isTrafalgarRiver">{{ data.tour_name }} - </span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.isADay && data.title" v-html="data.title"></span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.locations"> - </span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.days">{{ data.days.length }} days</span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.days && data.days[0] && data.days[0].locations"> - </span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.days && data.days[0]">{{ data.days[0].locations | custom-join('name') }}</span>
        <span :class="{ 'ml-2': isDropped }" v-if="data && data.locations">{{ data.locations | custom-join('name') }}</span>
      </span>
      <span
        style="width: 140px;"
        class="fw-600 mb-1 text-right code-drag-drop"
        :class="{ 'text-info': !isDropped, 'text-color2': isDropped || isSelected }"
        v-if="data.code">CODE: {{ data.code }}</span>
      <span
        style="width: 140px;"
        class="fw-600 mb-1 text-right code-drag-drop"
        :class="{ 'text-info': !isDropped, 'text-color2': isDropped || isSelected }"
        v-if="data && data.isADay && data.itineraryCode">CODE: {{ data.itineraryCode }}</span>
    </div>
    <div class="mt-1">
      <p v-if="isTrafalgarRiver && data.start_date">
        Sailing Dates: {{ data.start_date }} to {{ data.end_date }}
      </p>
      <p class="mb-0">
        <span v-if="data.description" v-html="data.description"></span>
        <span v-if="data && data.textday && data.textday[0].textday" v-html="data.textday[0].textday"></span>
        <a href="" class="text-info ResultBox-toggleDescription ml-1" @click.prevent="toggleDescription" v-if="!showCompleteDescription && data.days">Show more</a>
        <a href="" class="text-info ResultBox-toggleDescription ml-1" @click.prevent="toggleDescription" v-if="showCompleteDescription && data.days">Show less</a>
      </p>
      <div v-if="showCompleteDescription">
        <div class="my-3" v-for="day in data.days" :key="day.id">
          <strong>Day {{ day.startday }}: <span v-html="day.title"></span></strong>
          <p class="mb-1" v-html="day.textday[0].textday"></p>
          <p class="my-0">
            <strong>Meals:</strong>&nbsp;
            <span v-for="meal in day.meals" :key="meal.id" v-html="meal.mealsday"></span>
          </p>
          <div
            class="kt-separator kt-separator--space-sm"
            v-if="data.days.length !== Number(day.startday)"></div>
        </div>
        <a href="" class="text-info ResultBox-toggleDescription ml-1" @click.prevent="toggleDescription" v-if="showCompleteDescription && data.days">Show less</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {BRAND} from "@/constants";

export default {
  name: 'ResultsBox',
  data () {
    return {
      showCompleteDescription: false
    }
  },
  computed: {
    isTrafalgarRiver() {
      return this.data.brand_code === BRAND.TRAFALGAR_RIVER;
    },
    isSelected () {
      if (this.selected) {
        return this.selected.id === this.data.id
      }
      return false
    }
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: {
        brand_code: "",
        tour_name: "",
        start_date: "",
        end_date: "",
      },
    },
    isDropped: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    order: {
      type: Number,
      default: 0,
      required: false
    },
    isSelectable: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Object,
      required: false
    }
  },
  methods: {
    toggleDescription () {
      this.showCompleteDescription = !this.showCompleteDescription
    }
  }
}
</script>

<style lang="scss" scoped>
  .kt-portlet {
    cursor: pointer;
    transition: background-color ease-in .2s;
    margin-bottom: 5px !important;
  }
  .kt-portlet:hover {
    background-color: #ffffff;
  }
  .kt-portlet__head {
    min-height: 30px;
    align-items: center;
    background-color: #999999;
    color: white !important;
    border-bottom: 0;
    padding: 5px 10px!important;
  }
  .kt-portlet__head.isDropped {
    background-color: #5cb85cff;
  }
  .kt-portlet__head-title {
    font-size: 1rem !important;
    color: white !important;
  }
  .kt-portlet__body {
    color: #032647;
    padding: 10px 10px!important;
    font-weight: 500;
  }
  .kt-portlet.collapsed .kt-portlet__body {
    height: 0;
    overflow: hidden;
    padding: 0 !important;
    transition: all 0.3s ease-out;
  }
  .ResultBox-toggleDescription {
    font-size: .86rem;
    font-weight: 500;
    text-decoration: underline;
  }
  .kt-portlet__head-title .ml-2{
    position: relative;
    top: -1px;
  }
  .text-color2{
    color: #c1323e!important;
  }
</style>
